import { useEffect, useState } from "react"
import Input from "../form-components/Input";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/loader/Loader";
import { sendShareDocumentSettings } from "../../features/chatbot/sendShareDocumentSettings";
import { getSite } from "../../features/chatbot/getSiteDataSlice";
import { showSuccess } from "../../utils/messageHelper";
import { OK } from "../../constants/statusCode";

const ChatSetting = () => {
    const dispatch = useDispatch();
    const { isLoading } = useSelector(state => state.sendShareDocumentSettingsReducer);
    const { siteData } = useSelector((state) => state.getSiteData);
    const [initialMessage, setInitialMessage] = useState(siteData?.details?.project_setting?.initial_message ?? "");
    const [inputError, setInputError] = useState("");
    const userData = JSON.parse(localStorage.getItem("_user"));
    const handleChange = (event) => {
        setInitialMessage(event.target.value);
    }

    useEffect(() => {
        if (userData.projects[0]?.slug) {
            dispatch(getSite(userData.projects[0].slug));
        }
    }, []);

    useEffect(() => {
        if (siteData?.details?.project_setting?.initial_message) {
            setInitialMessage(siteData.details.project_setting.initial_message);
        }
    }, [siteData]);

    const save = async () => {
        if (!initialMessage) {
            setInputError("Please enter initial message");
            return;
        }
        setInputError("");
        const response = await dispatch(sendShareDocumentSettings({
            values: { initial_message: initialMessage },
            project_slug_name: userData.projects[0]?.slug,
        }));
        if (response.payload?.status === OK) {
            showSuccess("Settings saved");
        }
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="d-flex justify-content-end flex-column">
                <div className="form-group w-50">
                    <label className="form-label">Initial Message</label>
                    <Input
                        type="text"
                        placeholder="Initial Message"
                        className="form-control"
                        value={initialMessage}
                        onChange={handleChange}
                    />
                    <span className="text-danger">{inputError}</span>
                    <div className="mt-2 text-end">
                        <span
                            className="reset-btn"
                            onClick={() => setInitialMessage("Hi! What can I help you with?")}
                        >
                            Reset
                        </span>
                    </div>
                </div>
                <div className="d-flex">
                    <button
                        type="button"
                        className="btn btn-primary-md col-1"
                        onClick={save}
                    >
                        Save
                    </button>
                </div>
            </div>
        </>
    )
}

export default ChatSetting
